// @ts-nocheck
export default function getFocalPointStyles(
    focalPoint:
        | "topLeft"
        | "topCenter"
        | "topRight"
        | "centerLeft"
        | "center"
        | "centerRight"
        | "bottomLeft"
        | "bottomCenter"
        | "bottomRight",
    cssProperty?: "background-position" | "object-position", // Starter Custom Code
) {
    const _cssProperty = cssProperty || "background-position"; // Starter Custom Code
    let focalPointStyles;
    switch (focalPoint) {
        case "topLeft":
            focalPointStyles = `${_cssProperty /* Starter Custom Code */}: left top;`;
            break;
        case "topCenter":
            focalPointStyles = `${_cssProperty /* Starter Custom Code */}: center top;`;
            break;
        case "topRight":
            focalPointStyles = `${_cssProperty /* Starter Custom Code */}: right top;`;
            break;
        case "centerLeft":
            focalPointStyles = `${_cssProperty /* Starter Custom Code */}: left center;`;
            break;
        case "center":
            focalPointStyles = `${_cssProperty /* Starter Custom Code */}: center center;`;
            break;
        case "centerRight":
            focalPointStyles = `${_cssProperty /* Starter Custom Code */}: right center;`;
            break;
        case "bottomLeft":
            focalPointStyles = `${_cssProperty /* Starter Custom Code */}: left bottom;`;
            break;
        case "bottomCenter":
            focalPointStyles = `${_cssProperty /* Starter Custom Code */}: center bottom;`;
            break;
        case "bottomRight":
            focalPointStyles = `${_cssProperty /* Starter Custom Code */}: right bottom;`;
            break;
    }

    return focalPointStyles;
}
